module.exports = __webpack_public_path__ + "media/images/book-a195d75034718f3684e29ad06168224c.png";